import React, {useEffect, useState} from "react";
import {ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/16/solid";
import {sort} from "../../../../scout_dashboard/pro/datatable/util";

function SortableHeader({ sortDir, activeColumn, value, column, update }) {
  const [visible, setVisible] = useState(false);

  function handleClick(e) {
    e.preventDefault();
    if(activeColumn !== column) {
      update(column, 'asc');
    } else if(sortDir === 'asc') {
      update(column, 'desc')
    } else if(sortDir === 'desc') {
      update('id', 'desc')
    } else if(sortDir === '') {
      update(column, 'asc')
    } else {
      console.error(`Invalid sort dir ${sortDir}`)
    }
  }

  function handleMouseEnter(e) {
    e.preventDefault();
    setVisible(true);
  }

  function handleMouseLeave(e) {
    e.preventDefault();
    setVisible(false)
  }

  function renderSortIcon() {
    if((activeColumn !== column) || sortDir === '') {
      return (
        <span className={`ml-2 flex-none rounded bg-gray-100 text-gray-400 ${visible ? '' : 'invisible'}`}>
          <ChevronUpIcon className="h-4 w-4 text-gray-500 hover:text-blue-600" />
        </span>
      )
    } else if(sortDir === 'asc') {
      return (
        <span className="ml-2 flex-none rounded bg-gray-200 text-gray-900 group-hover:bg-gray-600">
          <ChevronUpIcon className="h-4 w-4 text-gray-500 hover:text-blue-600" />
        </span>
      )
    } else if(sortDir === 'desc') {
      return (
        <span className="ml-2 flex-none rounded bg-gray-200 text-gray-900 group-hover:bg-gray-600">
            <ChevronDownIcon className="h-4 w-4 text-gray-500 hover:text-blue-600" />
          </span>
      )
    }
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className='flex items-center cursor-default hover:cursor-pointer' onClick={handleClick}>
      <span>{ value }</span>
      { renderSortIcon() }
    </div>
  )
}

export default  SortableHeader;